/**
 * Created by user on 2020/5/29.
 */

import table_cn2tw from './table_cn2tw.json'
import { ITable } from '../types';

export = table_cn2tw as ITable
